import api from "../../../api.js";

export async function searchMedications(params = {}) {
  const { search, branchcode, departmentid } = params;
  const res = await api.get("/api/medications/search", { params: { search, branchcode, departmentid } });
  return res.data?.data || [];
}

export async function getMedicationBySku(sku) {
  const res = await api.get(`/api/medications/${encodeURIComponent(sku)}`, {
    params: { t: Date.now() }
  });
  return res.data?.data;
}

// Fetch medications that share the same ICD-10 code (server must support this route)
export async function getMedicationsByICD10(code, params = {}) {
  const { branchcode } = params;
  const res = await api.get("/api/medications/icd10", { params: { code, branchcode } });
  return res.data?.data || [];
}